import { Component, inject } from "@angular/core"
import { StepsService } from "src/app/services/steps.service"

@Component({
  selector: "ow-order-steps",
  templateUrl: "./order-steps.component.html"
})
export class OrderStepsComponent  {
  public readonly stepsService = inject(StepsService)
}
